export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const CLINIC_ID = "CLINIC_ID";
export const CLIENT_ID = "CLIENT_ID";
export const CLIENT_INSURANCE_ID = "CLIENT_INSURANCE_ID";

export const SELECTED_CLIENT_ID = "SELECTED_CLIENT_ID";
export const SELECTED_CLIENT_FILTER = "SELECTED_CLIENT_FILTER";

export const REMOVE_CLIENT_FILTER = "REMOVE_CLIENT_FILTER";
export const SELECTED_STAFF_ID = "SELECTED_STAFF_ID";
export const SELECTED_SERVICE_FILTER = "SELECTED_SERVICE_FILTER";
export const GET_STAFF = "GET_STAFF";
export const GET_MARITIALS_STATUS = "GET_MARITIALS_STATUS";
export const GET_GENDER = "GET_GENDER";

export const SELECTED_SERVICE_ID = "SELECTED_SERVICE_ID";
export const STAFF_LOGIN_DETAIL = "STAFF_LOGIN_DETAIL";

export const IMMUNIZATION_ID = "IMMUNIZATION_ID";

export const SELECTED_DRAWER_ROUTE = "SELECTED_DRAWER_ROUTE";
export const SELECTED_HEADER_MENU = "SELECTED_HEADER_MENU";
export const IS_GLOBAL_SEARCH = "IS_GLOBAL_SEARCH";
export const GET_ROLE = "GET_ROLE";
export const GET_CLIENT_DETAILS = "GET_CLIENT_DETAILS";
export const AGE_CAlCULATION = "AGE_CAlCULATION";
export const GET_CLIENT_PROFILE_IMG = "GET_CLIENT_PROFILE_IMG";
export const GET_STAFF_DETAILS = "GET_STAFF_DETAILS";
export const GET_STAFF_PROFILE_IMG = "GET_STAFF_PROFILE_IMG";

// -----------------------------Admin----------------------------

export const GET_ALL_CLINIC = "GET_ALL_CLINIC";
export const GET_REGION = "GET_REGION";
export const TEMPLATE_TYPE = "TEMPLATE_TYPE";
export const SAVE_DEFULT_DOCUMENT_TEMPLATE = "SAVE_DEFULT_DOCUMENT_TEMPLATE";
export const GET_CLINIC_STATUS = "GET_CLINIC_STATUS";
export const GET_CLINIC_LIST_SELECTED_STATE = "GET_CLINIC_LIST_SELECTED_STATE";
export const GET_CLINIC_STATES = "GET_CLINIC_STATES";
export const SHOW_CLINICS_WITHOUT_STRIPE_GLOBAL_STATE = "SHOW_CLINICS_WITHOUT_STRIPE_GLOBAL_STATE";
export const SHOW_CLINICS_WITH_SMS_NOTIFICATIONS = "SHOW_CLINICS_WITH_SMS_NOTIFICATIONS";
export const SHOW_RCM_CLINICS_GLOBAL_STATE = "SHOW_RCM_CLINICS_GLOBAL_STATE";
// ----------------------------Announcement -----------------------------------
export const SELECTED_ANNOUNCEMENT_FILTER = "SELECTED_ANNOUNCEMENT_FILTER";

// ----------------------------Subpoena Request-----------------------------------
export const GET_SUBPOENA_REQUESTS = "GET_SUBPOENA_REQUESTS";
export const GET_SUBPOENA_REQUEST_DETAILS = "GET_SUBPOENA_REQUEST_DETAILS";
export const GET_SUBPOENA_MODULES = "GET_SUBPOENA_MODULES";
export const SELECTED_SUBPOENA_REGION_FILTER = "SELECTED_SUBPOENA_REGION_FILTER";

// ----------------------------SMS Lookup Filter----------------------------
export const SMS_LOOKUP_FILTER = "SMS_LOOKUP_FILTER";

// ----------------------------Customer Status----------------------------
export const GET_CUSTOMER_STATUSES = "GET_CUSTOMER_STATUSES";
export const GET_SELECTED_CUSTOMER_STATUS ="GET_SELECTED_CUSTOMER_STATUS";